/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneCourseCountdown as ResolvedStandaloneCourseCountdown } from 'base/components/standalone/CourseCountdown';

export const CourseCountdown: typeof ResolvedStandaloneCourseCountdown = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneCourseCountdown {...props} />
        </ErrorBoundary>
    );
});

export type CourseCountdownProps = PropsFromComponent<typeof CourseCountdown>;

/** @deprecated Use slot architecture instead */
export const CourseCountdownWith = (extras: DynamicStandaloneExtras): typeof CourseCountdown => {
    return function CourseCountdown(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'CourseCountdown');
        return <ResolvedStandaloneCourseCountdown {...mergeProps({ options: { theme } }, props)} />;
    }
}